import React, { useMemo } from 'react';

const NotificationsBubble = ({ count, typeDot, typeLabel, className = '' }) => {
    const content = useMemo(() => {
        if (typeDot) {
            return null;
        }

        if (count >= 100) {
            return '99+';
        }

        return count;
    }, [typeDot, count]);

    if (!count) {
        return null;
    }

    return (
        <span className={'notification-bubble ' + className + (typeDot ? ' type-dot' : '') + (typeLabel ? ' type-label' : '')}>{ content }</span>
    );

};

export default NotificationsBubble;
